// @flow
import styled from 'styled-components'
import { Row } from 'antd'

export const StyledRow = styled(Row) `
  padding-top: 20px;
  & button {
    width: 100%;
  }
`



// WEBPACK FOOTER //
// ./src/components/form-calculator-volatility/style.js